<script setup>
const props = defineProps({
    loading: {
        type: Boolean,
        required: true,
    },
});

const loaderSrc = '/img/2026/loader/loader.png';
</script>

<template>
    <Transition name="fade">
        <img v-if="loading"
            :src="loaderSrc"
            class="mess-loader"
            alt="Loading"
            aria-hidden="true"
            width="59"
            height="55" />
    </Transition>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.mess-loader {
    display: block;
    width: 59px;
    height: 55px;
    animation: mess-loader-spin 1.4s ease-in-out infinite;
}

@keyframes mess-loader-spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
    .mess-loader {
        animation: none;
    }
}
</style>
